/* eslint-disable */
import Vue from 'vue'

class MediaDevices {
  constraints:Object = {
    video: true,
    audio: true
  }
  navigator:any = window.navigator
  mediaStream:any = null
  mediaDevices:any = []
  device:any = {}
  debug:any = {
    error: null
  }

  errorHandler (error:any, handler:String) {
    console.error({ error, handler })
  }

  promisifiedOldGUM (constraints:any, successCallback:any, errorCallback:any) {
    const getUserMedia = (this.navigator.getUserMedia ||
      this.navigator.webkitGetUserMedia ||
      this.navigator.mozGetUserMedia)

    if (!getUserMedia) {
      return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
    }

    return new Promise((successCallback, errorCallback) => {
      getUserMedia.call(this.navigator, constraints, successCallback, errorCallback);
    })
  }

  async enumerateDevices () {
    this.mediaDevices = []

    if (!this.navigator.mediaDevices || !this.navigator.mediaDevices.enumerateDevices) {
      console.log("enumerateDevices() not supported.")
      return false
    }

    return this.navigator.mediaDevices.enumerateDevices()
      .then((devices:any) => {
        devices.forEach((device:any) => {
          this.mediaDevices.push(device)
        })
      })
      .catch((error:any) => {
        this.debug.error = error
        console.log(`enumerateDevices: ${this.debug.error.name} ${this.debug.error.message}`)
      })
  }

  async getUserMedia () {
    this.mediaStream = null

    if (this.navigator.mediaDevices === undefined) {
      this.navigator.mediaDevices = {}
    }

    if (this.navigator.mediaDevices.getUserMedia === undefined) {
      this.navigator.mediaDevices.getUserMedia = this.promisifiedOldGUM
    }

    return this.navigator.mediaDevices.getUserMedia(this.constraints)
      .then((mediaStream:any) => {
        this.mediaStream = mediaStream
      })
      .catch((error:any) => {
        this.debug.error = error
        console.log(`getUserMedia: ${this.debug.error.name} ${this.debug.error.message}`)
      })
  }

  getDevice () {
    const userAgent = navigator.userAgent
    const lowerUserAgent = userAgent.toLowerCase()

    const mobile = (lowerUserAgent.indexOf('mobile') != -1)
    let browserName, so

    if (lowerUserAgent.indexOf('edg/') != -1) {
      browserName = 'Microsoft Edge'
    } else if (lowerUserAgent.indexOf('opr/') != -1 || lowerUserAgent.indexOf('opera/') != -1) {
      browserName = 'Opera'
    } else if (lowerUserAgent.indexOf('chrome/') != -1 || lowerUserAgent.indexOf('crios/') != -1) {
      browserName = 'Google Chrome'
    } else if (lowerUserAgent.indexOf('safari/') != -1) {
      browserName = 'Apple Safari'
    } else if (lowerUserAgent.indexOf('firefox') != -1) {
      browserName = 'Mozilla Firefox'
    }

    /** SO */
    if (lowerUserAgent.indexOf('win') != -1 || lowerUserAgent.indexOf('windows') != -1) {
      so = 'Windows'
    } else if (lowerUserAgent.indexOf('android') != -1) {
      so = 'Android'
    } else if (lowerUserAgent.indexOf('linux') != -1) {
      so = 'Linux'
    } else if (lowerUserAgent.indexOf('iphone') != -1) {
      so = 'iPhone'
    } else if (lowerUserAgent.indexOf('mac os') != -1 || lowerUserAgent.indexOf('macintosh') != -1) {
      so = 'MacOS'
    }

    this.device = {
      userAgent,
      mobile,
      browserName,
      so,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }

    return this.device
  }

  stopMediaStreamTracks () {
    if (!this.mediaStream) {
      return false
    }

    const tracks = this.mediaStream.getTracks()

    tracks.forEach((track:any) => {
      track.stop()
    })
  }

  async checkMediaAccess() {
    const result = {
      hasAccess: false,
      video: false,
      audio: false,
      errorMessage: ''
    };

    if (!this.navigator.mediaDevices || !this.navigator.mediaDevices.getUserMedia) {
      result.errorMessage = "Este navegador no soporta acceso a dispositivos multimedia";
      return result;
    }

    const checkDevice = async (type: string) => {
      const constraints = {
        video: type === 'video',
        audio: type === 'audio'
      };

      try {
        const stream = await this.navigator.mediaDevices.getUserMedia(constraints);

        if (stream && stream.getTracks) {
          stream.getTracks().forEach((track: any) => {
            if (track && typeof track.stop === 'function') {
              track.stop();
            }
          });
        }

        return true;
      } catch (error: any) {
        const errorType = error.name || '';

        if (errorType === 'NotAllowedError' || errorType === 'PermissionDeniedError') {
          console.log(`Acceso a ${type} denegado por el usuario`);
        } else {
          console.log(`Error al verificar acceso a ${type}: ${errorType} ${error.message || ''}`);
        }

        return false;
      }
    };

    try {
      const [videoAccess, audioAccess] = await Promise.all([
        checkDevice('video'),
        checkDevice('audio')
      ]);

      result.video = videoAccess;
      result.audio = audioAccess;
      result.hasAccess = videoAccess || audioAccess;

      if (!result.hasAccess) {
        result.errorMessage = "No se tiene acceso a cámara ni micrófono";
      } else if (!videoAccess) {
        result.errorMessage = "No se tiene acceso a la cámara";
      } else if (!audioAccess) {
        result.errorMessage = "No se tiene acceso al micrófono";
      }
    } catch (error: any) {
      this.debug.error = error;
      console.error(`checkMediaAccess: Error general: ${error.message || 'Error desconocido'}`);
      result.errorMessage = `Error al verificar acceso: ${error.message || 'Error desconocido'}`;
    }

    return result;
  }
}

export default new MediaDevices()
Vue.prototype.$mediaDevices = new MediaDevices()
